// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zJlAP","left":"styles_left__1fFyG"};